import { 
    GetLineup as DLGetLineup, 
    SaveLineup as DLSaveLineup, 
    TriggerPresentation as DLTriggerPresentation 
} from './../DL/Lineup';

const GetLineup = async (teamType) => {
    try {
        if (!teamType || (teamType.toLowerCase() !== 'local' && teamType.toLowerCase() !== 'away')) {
            return { success: false, message: 'Tipo de equipo inválido. Debe ser Local o Away.' };
        }

        const response = await DLGetLineup(teamType);
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, message: response.message };
        }
    } catch (error) {
        return { success: false, message: 'No ha sido posible consultar la alineación. Inténtalo más tarde.' };
    }
};

const SaveLineup = async (payload) => {
    try {
        // Validaciones básicas de integridad
        if (!payload.teamType || !payload.teamId) {
            return { success: false, message: 'Faltan datos obligatorios del equipo para guardar la alineación.' };
        }

        if (!payload.players || !Array.isArray(payload.players)) {
            return { success: false, message: 'La lista de jugadores no tiene un formato válido.' };
        }

        const response = await DLSaveLineup(payload);
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, message: response.message };
        }
    } catch (error) {
        return { success: false, message: 'Ocurrió un error inesperado al procesar la alineación.' };
    }
};

const TriggerPresentation = async (action, playerId = null) => {
    try {
        if (!action) {
            return { success: false, message: 'La acción de presentación es obligatoria.' };
        }

        const payload = {
            action: action,
            playerId: playerId
        };

        const response = await DLTriggerPresentation(payload);
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, message: response.message };
        }
    } catch (error) {
        return { success: false, message: 'No fue posible ejecutar la presentación en la pantalla.' };
    }
};

// 1. Obtener la configuración de deportes (Sustituye el hardcodeo)
const GetSportModes = async () => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}SportsCatalog/modes`);
        if (!res.ok) throw new Error("Error al cargar modos deportivos");
        return await res.json();
    } catch (error) {
        console.error(error);
        return null;
    }
};

// 2. Lógica para calcular posiciones (Separada del View)
const CalculateFormationPositions = (formName, currentMode, sportConfig, teamType, currentPlayers) => {
    const modeData = sportConfig.find(m => m.code === currentMode);
    const coords = modeData?.formations[formName];
    if (!coords) return [];

    return coords.map((c, index) => {
        const existingPlayer = currentPlayers[index];
        return {
            playerId: existingPlayer?.playerId || '',
            name: existingPlayer?.name || 'VACÍO',
            dorsal: existingPlayer?.dorsal || 0,
            isCaptain: existingPlayer?.isCaptain || false,
            positionX: teamType === 'Local' ? c.l : 100 - c.l,
            positionY: c.t
        };
    });
};

export { GetLineup, SaveLineup, TriggerPresentation, GetSportModes, CalculateFormationPositions };